import { useUsersProfilePic } from '@/hooks/useUsersProfilePic';
import { cn } from '@/utils';

export interface ParticipantAvatarItem {
  key: string | number;
  alt: string;
  dtName: string;
  photoUrl?: string;
}

interface ParticipantsAvatarStackProps {
  participants: ParticipantAvatarItem[];
  total: number;
  zIndexBase?: number;
  maxVisible?: number;
  clickableLimit?: number;
  onClick: () => void;
}

const classCircleBlue =
  'w-[30px] h-[30px] rounded-full bg-gdt-blue flex items-center justify-center  shrink-0';

const whiteText = 'text-white text-3xs font-bold';

export const ParticipantsAvatarStack = ({
  participants,
  total,
  zIndexBase = total,
  maxVisible = 6,
  clickableLimit = 200,
  onClick,
}: ParticipantsAvatarStackProps) => {
  const { setProfilePic } = useUsersProfilePic();
  const isClickable = total <= clickableLimit && total !== -1;

  return (
    <div className="flex -space-x-1 items-center mt-3 relative z-0">
      {participants.slice(0, maxVisible).map((item, index) => (
        <div
          key={item.key}
          className={cn(
            'rounded-full ring-2 ring-white shrink-0 text-gdt-blue',
            {
              'cursor-pointer': isClickable,
            }
          )}
          style={{ zIndex: zIndexBase - index }}
          onClick={() => isClickable && onClick()}
        >
          {setProfilePic(
            {
              alt: item.alt,
              dtName: item.dtName,
              url: item.photoUrl,
              size: 30,
            },
            '!bg-gdt-blue-light2 text-xs font-medium'
          )}
        </div>
      ))}

      {total === -1 && (
        <div
          className={cn(classCircleBlue, { 'cursor-pointer': isClickable })}
          onClick={() => isClickable && onClick()}
        >
          <span className={whiteText}>...</span>
        </div>
      )}
      {total > maxVisible && (
        <div
          className={cn(classCircleBlue, { 'cursor-pointer': isClickable })}
          onClick={() => isClickable && onClick()}
        >
          <span className={whiteText}>+{total - maxVisible}</span>
        </div>
      )}
    </div>
  );
};
